export default __webpack_public_path__ + "static/media/willowtree.01da5945.PNG";